import type WhiteboardController from '../controllers/WhiteboardController';
import ClientBase from './ClientBase';
import Serialization from './Serialization';

// Dummy client used in read-only mode. Does not actually communicate with the
// collaboration server.
class LoopbackClient extends ClientBase {
  initialize(initialVersion, initialData) {
    this.processingRemoteOps = true;
    Serialization.restoreDocument(this.controller, initialData);

    // Make sure that the user can see some objects on the screen.
    setTimeout(() => this.controller.actionZoomIntoView());
  }

  constructor(controller: WhiteboardController) {
    super(controller, true);
  }
}

export default LoopbackClient;
